import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DxoPopupComponent } from 'devextreme-angular/ui/nested';
import notify from 'devextreme/ui/notify';
import { alert, confirm } from 'devextreme/ui/dialog';
import * as dayjs from 'dayjs';
import { AppointmentBookService } from 'src/app/services/appointment-book.service';
import { ConstantsService } from 'src/app/services/constants.service';
import { SessionContextService } from 'src/app/services/session-context.service';
import { Appointment, AppointmentState } from 'src/app/shared/model/appointment-book.models';
import { BookAptInfo } from '../../model/BookAptInfo';
import { ClientFinderComponent } from '../client-finder/client-finder.component';
import { Resource, Session } from '../../model/resource.model';
import { TransactionService } from 'src/app/services/transaction.service';
import { enumProductClass, enumSaleItemType, SaleItem } from '../../model/SaleItem';
import { Observable, of, Subscription } from 'rxjs';
import { EventService } from 'src/app/services/event.service';
import { map, take } from 'rxjs/operators';
import { ClientService } from 'src/app/services/client.service';
import { SessionDelay } from '../edit-session-delays/edit-session-delays.component';
import { AppointmentTimeComponent } from '../appointment-time/appointment-time.component';
import { _isMoreThanOneDataSourceTypeAvailable } from '@devexpress/analytics-core/analytics-wizard-internal';
import { ResourceManagerService, ResourceStateInfo } from 'src/app/services/resource.manager.service';
import { SessionTile } from '../appointment-session/appointment-session.component';
// import { AppointmentTimeComponent } from '../appointment-time/appointment-time.component';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import { LookupItem } from '../../model/AS365Defaults.model';

export class AptBookerResponse {
  refreshAppointmentBook = false;
  apt: Appointment = null;
  aptInfo: BookAptInfo = null;
}

@Component({
  selector: 'app-appointment-booker',
  templateUrl: './appointment-booker.component.html',
  styleUrls: ['./appointment-booker.component.css']
})
export class AppointmentBookerComponent implements OnInit, OnDestroy, AfterViewInit {

  bookAptInfo: BookAptInfo = new BookAptInfo();
  goFullScreen = false;

  sessions: Session[] = [];
  sessionCategories: LookupItem[] = [];
  sessionCategoryLookup: any;
  isSessionCategoryDataLoaded: boolean = false;
  sessionTiles: SessionTile[] = [];
  resources: Resource[] = [];
  showResourcesLoading = false;
  lookupResources: Resource[] = [];

  clientAge: number = undefined;

  PreSessionDelay: number = 3;
  PostSessionDelay: number = 3;

  onDefaultDataChanged$: Subscription;

  resourceStateInfo: ResourceStateInfo[];
  onResourceStateUpdated$: Subscription;
  showPaymentAfterSessionBookApt: boolean = false;

  @Input() public popupVisible = false;
  @Input() public appointmentData: Appointment[];
  @Input() public allowOverlap: boolean = false
  @Output() OnCloseForm = new EventEmitter<AptBookerResponse>();
  @Output() OnAppointmentBooked = new EventEmitter<Appointment>();

  @Output() OnAppointmentAttended = new EventEmitter<Appointment>();
  @Output() OnAppointmentCancelled = new EventEmitter<Appointment>();
  @Output() OnAppointmentSaleMade = new EventEmitter<Appointment>();

  @ViewChild(DxoPopupComponent, { static: false }) popup: DxoPopupComponent;
  @ViewChild(ClientFinderComponent, { static: false }) clientFinder: ClientFinderComponent;
  @ViewChild(AppointmentTimeComponent, { static: false }) appointmentTimeComponent: AppointmentTimeComponent;

  aptTime: Date = null;

  SaveButtonOptions: any = {
    text: 'Save',
    onClick: this.btnSave.bind(this),
  };

  CancelButtonOptions: any = {
    text: 'Cancel',
    onClick: this.btnCancel.bind(this),
  };

  constructor(
    private aptService: AppointmentBookService,
    private session: SessionContextService,
    private transactionService: TransactionService,
    private events: EventService,
    private clientService: ClientService,
    private changeDetectorRef: ChangeDetectorRef,
    public resourceMgr: ResourceManagerService,
  ) {
    this.onResourceStateUpdated$ = this.events.onResourceStateUpdated.subscribe((rs) => {
      this.resourceStateInfo = rs;
    });

    this.sessionCategoryLookup = AspNetData.createStore({
      key: 'Value',
      loadUrl: '/api/LookupData/GetProductCategoryLookup',
      onBeforeSend: (e, ajax) => {
        ajax = ConstantsService.AddDefaultHeaders(e, ajax);
        ajax.data.OnlyActive = 99999;
        ajax.data.ProductClass = enumProductClass.Session;
      },
      onLoaded: this.sessionCategoryDataLoaded.bind(this),
    });
    this.sessionCategoryLookup.load();
  }

  ngAfterViewInit(): void {
    this.updateUI();
  }

  ngOnInit(): void {
    this.onDefaultDataChanged$ = this.events.onDefaultDataChanged.subscribe(r => {
      this.getData().pipe(take(1)).subscribe();
    });
  }

  ngOnDestroy(): void {
    if (this.onDefaultDataChanged$) {
      this.onDefaultDataChanged$.unsubscribe();
    }
    if (this.onResourceStateUpdated$) {
      this.onResourceStateUpdated$.unsubscribe();
    }
  }

  onShowing(e) {
    this.bookAptInfo.branchId = this.session.ctx.BranchId;
    this.updateUI();
  }

  onHiding(e) {
    this.CloseForm(true);
  }

  btnResetBooker() {
    // this.ResetForm();
  }

  btnFullScreenToggle() {
    this.goFullScreen = !this.goFullScreen;
  }

  btnClose() {
    this.CloseForm(true);
  }

  btnSave() {
    // Save Data
    notify('Save was clicked');
    this.CloseForm(true);
  }

  btnCancel() {
    notify('Cancel was clicked');
    this.CloseForm(false);
  }

  Show(apt: Appointment, paymentAfterSession: boolean = false) {
    this.ResetForm();
    if (apt) {
      this.bookAptInfo.apt = apt;
      this.bookAptInfo.appointmentId = apt.AppointmentId;
      this.bookAptInfo.clientId = apt.ClientId;
      this.bookAptInfo.requestedStartTime = apt.StartDateTime;
      this.bookAptInfo.startTime = apt.StartDateTime;
      this.bookAptInfo.resourceId = apt.ResourceId;
      this.bookAptInfo.sessionId = apt.SessionId;
      this.bookAptInfo.State = apt.State;
      this.bookAptInfo.waitTime = Math.abs(Appointment.GetMinutesBetweenAptAndTime(apt.StartDateTime, new Date()));
      this.bookAptInfo.PreSessionDelay = apt.PreSessionDelay;
      this.bookAptInfo.PostSessionDelay = apt.PostSessionDelay;
      this.bookAptInfo.Locked = apt.Locked;

      if (apt.PreSessionDelay)
        this.PreSessionDelay = apt.PreSessionDelay;
      else
        this.bookAptInfo.PreSessionDelay = this.session.defaultData.defData.customerSettings.PreSessionDelay;

      // this.bookAptInfo.PostSessionDelay = this.session.defaultData.defData.customerSettings.PostSessionDelay;
      if (apt.PostSessionDelay)
        this.PostSessionDelay = apt.PostSessionDelay;
      else
        this.bookAptInfo.PostSessionDelay = this.session.defaultData.defData.customerSettings.PostSessionDelay;

      if (apt.State < AppointmentState.Paid || (paymentAfterSession && apt.State == AppointmentState.InProgress)) {
        const s = this.session.defaultData.defData.Sessions.find(i => i.SessionId === apt.SessionId);
        if (s) {
          this.transactionService.AddSession(s);
          const r = this.session.defaultData.defData.Resources.find(i => i.ResourceId === apt.ResourceId);
          if (r) {
            this.aptService.GetResourcesAndWaitTimes(
              this.bookAptInfo.requestedStartTime, -1, this.session.ctx.BranchId, this.bookAptInfo.clientId, this.bookAptInfo.sessionId, this.PreSessionDelay, this.PostSessionDelay)
              .pipe(take(1)).subscribe(res => {
                this.lookupResources = res || [];
                const resource = this.lookupResources.find(i => i.ResourceId === apt.ResourceId);
                if (resource) {
                  this.transactionService.AddResource(resource);
                  this.getData().pipe(take(1)).subscribe(_ => {
                    this.changeDetectorRef.detectChanges();
                  });
                }
              });
          }
        }
      }

    } else {
      this.bookAptInfo.requestedStartTime = new Date();
      this.bookAptInfo.State = AppointmentState.New;
      this.bookAptInfo.startTime = new Date(this.bookAptInfo.requestedStartTime);
      this.bookAptInfo.PreSessionDelay = this.session.defaultData.defData.customerSettings.PreSessionDelay;
      this.bookAptInfo.PostSessionDelay = this.session.defaultData.defData.customerSettings.PostSessionDelay;
      this.bookAptInfo.sessionId = -1;
      this.bookAptInfo.Locked = false;
    }

    // setup data
    this.getData().pipe(take(1)).subscribe((_) => {
      // update UI
      this.updateUI();
      // show form
      this.popupVisible = true;
      this.changeDetectorRef.detectChanges();
    });
  }

  ResetForm() {
    this.aptTime = null;
    this.bookAptInfo.Reset();
    this.bookAptInfo.branchId = this.session.ctx.BranchId;
    this.bookAptInfo.employee = this.session.ctx.EmployeeId;
    this.bookAptInfo.PreSessionDelay = this.session.defaultData.defData.customerSettings.PreSessionDelay;
    this.bookAptInfo.PostSessionDelay = this.session.defaultData.defData.customerSettings.PostSessionDelay;
    this.bookAptInfo.State = AppointmentState.New;
    this.bookAptInfo.showClientFinder = false;

    this.PreSessionDelay = this.session.defaultData.defData.customerSettings.PreSessionDelay;
    this.PostSessionDelay = this.session.defaultData.defData.customerSettings.PostSessionDelay;

    if (this.clientFinder) { this.clientFinder.Reset(); }
    this.transactionService.Reset();
  }

  CloseForm(RefreshRequired: boolean): void {
    this.ResetForm();
    this.popupVisible = false;

    const response: AptBookerResponse = new AptBookerResponse();
    response.refreshAppointmentBook = RefreshRequired;
    response.aptInfo = this.bookAptInfo;
    response.apt = this.bookAptInfo.apt;

    this.OnCloseForm.emit(response);
  }

  sessionCategoryDataLoaded(e) {
    this.sessionCategories = e;
    this.setSessionTiles();
    this.isSessionCategoryDataLoaded = true;
  }

  setSessionTiles() {
    const sessionTiles = [];
    if (this.sessionCategories?.length > 0) {
      sessionTiles.push(
        ...this.sessionCategories
          .filter((i) => this.sessions.some((j) => j.ProductCategoryLink.some((k) => k.ProductCategory == i.Value)))
          .map((i) => {
            const tile = new SessionTile();
            tile.Description = i.Text;
            tile.Id = i.Value;
            tile.IsCategory = true;
            return tile;
          })
      );
    }

    if (this.sessions?.length > 0) {
      sessionTiles.push(
        ...this.sessions.map((i) => {
          const tile = new SessionTile();
          tile.CategoryIds = i.ProductCategoryLink.map((i) => i.ProductCategory);
          tile.Description = i.SessionName;
          tile.Id = i.SessionId;
          tile.IsCategory = false;
          tile.RetailPrice = i.RetailPrice;
          tile.Selected = i.Selected;
          return tile;
        })
      );
    }

    this.sessionTiles = [...sessionTiles];
  }

  getData(): Observable<any> {
    if (this.bookAptInfo.State < AppointmentState.Booked) {
      if (this.sessions.length < 2) {
        this.sessions = this.session.defaultData.defData.Sessions.filter(i =>
          (i.Branch === undefined || i.Branch === this.session.ctx.BranchId) && (i.Active === true));
        this.setSessionTiles();
      }
      this.sessions.forEach(i => i.Selected = (i.SessionId === this.bookAptInfo.sessionId));
    } else {
      if ((this.sessions.length === 0) || (this.sessions[0].SessionId !== this.bookAptInfo.sessionId)) {
        this.sessions = this.session.defaultData.defData.Sessions.filter((i) => i.SessionId === this.bookAptInfo.sessionId && i.Active === true);
        this.setSessionTiles();
      }
    }

    if (this.bookAptInfo.sessionId && (this.bookAptInfo.sessionId > 0) && this.bookAptInfo.requestedStartTime) {
      if ((this.bookAptInfo.State < AppointmentState.Booked) || (!this.bookAptInfo.resourceId)) {
        this.showResourcesLoading = true;
        return this.aptService.GetResourcesAndWaitTimes(
          this.bookAptInfo.requestedStartTime, -1, this.session.ctx.BranchId, this.bookAptInfo.clientId, this.bookAptInfo.sessionId, this.PreSessionDelay, this.PostSessionDelay)
          .pipe(take(1), map((r) => {
            this.resources = r || [];
            this.resources = this.resources.sort((a, b) => this.session.defaultData.defData.customerSettings.OrderResourcesByRunningTotals 
              ? a.RunningTotal - b.RunningTotal 
              : (a.ResourceName > b.ResourceName ? 1 : -1));

            this.resources = this.resources.filter(i => (!i.MinimumAge) || (i.MinimumAge <= this.clientAge));
            if (this.resources.length < r.length) {
              alert("Some resources have a minimum age restriction. To access these resources please update the client's date of birth.", 'Minimum Age Restrictions');
            }
            this.resources.forEach(i => i.Selected = (i.ResourceId === this.bookAptInfo.resourceId));

            this.showResourcesLoading = false;
            this.changeDetectorRef.detectChanges();
          }));

      } else {
        if (this.lookupResources && (this.lookupResources.length > 0)) {
          this.resources = this.lookupResources.filter(i => i.ResourceId === this.bookAptInfo.resourceId);
        } else {
          this.resources = this.session.defaultData.defData.Resources.filter(i => i.ResourceId === this.bookAptInfo.resourceId);
        }
        this.resources.forEach(i => i.Selected = true);
        return of(this.resources);
      }
    } else {
      this.resources = [];
      return of(this.resources);
    }
  }

  updateResourceStates(){
    if ((this.bookAptInfo.sessionId!=null) && this.resources && this.resourceStateInfo) {
      this.resources = [
        ...this.resources.map((i) => {
          i.State = this.resourceStateInfo?.find((j) => j.ResourceId == i.ResourceId).State;
          return i;
        }),
      ];

      this.changeDetectorRef.detectChanges();
    }
  }

  updateUI(updatedDelays = false, updatedDateTime = false) {
    this.bookAptInfo.showClientFinder = !(this.bookAptInfo.clientId > 0);
    this.bookAptInfo.showClientInfo = this.bookAptInfo.clientId > 0;
    this.bookAptInfo.showDateTimePanel = this.bookAptInfo.showClientInfo && (this.bookAptInfo.requestedStartTime != null);
    this.bookAptInfo.showSessionResourcePanel = this.bookAptInfo.showClientInfo;

    const hasSessionAndResource = this.bookAptInfo.showSessionResourcePanel
      && (this.bookAptInfo.sessionId > 0)
      && (this.bookAptInfo.resourceId > 0);

    this.bookAptInfo.showMakeSalePanel = hasSessionAndResource
      && (this.bookAptInfo.requestedStartTime == null || (this.bookAptInfo.requestedStartTime != null
        && ConstantsService.isToday(this.bookAptInfo.requestedStartTime).valueOf()));

    if (this.bookAptInfo.showMakeSalePanel) {
      const dtRequested2 = (this.bookAptInfo.State === AppointmentState.New) ?
        dayjs(this.bookAptInfo.requestedStartTime).add(this.bookAptInfo.waitTime, 'minutes') : dayjs(this.bookAptInfo.requestedStartTime);

      // can we make sale and do we have a till?
      const session: Session = this.session.defaultData.defData.Sessions.find((i) => i.SessionId == this.bookAptInfo.sessionId);
      if ((Appointment.CanMakeSaleEx(this.bookAptInfo.State, dtRequested2.toDate(), this.session.defaultData.defData.customerSettings, session, this.resourceMgr) === false)
        || (this.session.DoesTerminalHaveTill() === false)) {
        this.bookAptInfo.showMakeSalePanel = false;
      }
    }

    this.bookAptInfo.showBookApt = hasSessionAndResource
      && (!updatedDelays)
      && (!this.bookAptInfo.showMakeSalePanel)
      && (this.bookAptInfo.requestedStartTime !== null)
      && ((this.bookAptInfo.State === AppointmentState.New) || (this.bookAptInfo.startTime !== this.bookAptInfo.requestedStartTime));

    this.showPaymentAfterSessionBookApt = (updatedDateTime || updatedDelays) && this.resourceMgr.IsResourcePaymentAfterSession(this.bookAptInfo.resourceId);

    this.changeDetectorRef.detectChanges();
  }

  onClientSelected(selectedClientId) {      
    console.log('AptBooker - Client Selected ', selectedClientId);

    var clientChanged = (selectedClientId!=this.bookAptInfo.clientId);

    this.bookAptInfo.clientId = (selectedClientId > 0) ? selectedClientId : -1;
    if (this.bookAptInfo.clientId > 0) {
      this.clientService.GetClient(this.bookAptInfo.clientId).pipe(take(1)).subscribe((client) => {
        this.clientAge = (client && client.DateOfBirth) ? dayjs(new Date()).diff(client.DateOfBirth, 'year') : 0;
        if (client != null) {
          if (client.PreSessionDelay != null) {
            this.bookAptInfo.PreSessionDelay = client.PreSessionDelay;
            this.bookAptInfo.apt.PreSessionDelay = client.PreSessionDelay;
            this.PreSessionDelay = client.PreSessionDelay;
            this.appointmentTimeComponent.PreSessionDelay = client.PreSessionDelay;
          }
          if (client.PostSessionDelay != null) {
            this.bookAptInfo.PostSessionDelay = client.PostSessionDelay;
            this.bookAptInfo.apt.PostSessionDelay = client.PostSessionDelay;
            this.PostSessionDelay = client.PostSessionDelay;
            this.appointmentTimeComponent.PostSessionDelay = client.PostSessionDelay;
          }
        }
      });
    }    
    
    if (clientChanged==true)
    {
      this.aptTime = new Date();
      this.bookAptInfo.sessionId = -1;
    }

    this.updateUI();
  }

  onDateTimeChanged(e) {
    this.bookAptInfo.requestedStartTime = e;
    this.getData().pipe(take(1)).subscribe(() => {

      this.updateResourceStates();

      // re-select resource - this will update the transaction, timings and UI
      if (this.resources && (this.resources.length > 0) && this.bookAptInfo.resourceId) {
        const resource = this.resources.find(i => i.ResourceId === this.bookAptInfo.resourceId);
        if (resource) {
          this.onResourceSelected(resource, false, true);
        }
      }
    });
  }

  onAttendAppointment() {
    if (this.bookAptInfo.appointmentId > 0) {
      this.OnAppointmentAttended.emit(this.bookAptInfo.apt);
      this.CloseForm(true);
    }
  }

  onCancelAppointment() {
    if (this.bookAptInfo.appointmentId > 0) {
      const sdt = dayjs(this.bookAptInfo.requestedStartTime).format('dddd, d MMM HH:mm');
      const msg = `Are you sure you want to cancel the appointment for ${this.bookAptInfo.apt.ClientName} at ${sdt} with session ${this.bookAptInfo.apt.SessionName} on ${this.bookAptInfo.apt.ResourceName}`;
      const dlg = confirm(msg, 'Cancel Appointment');
      dlg.then((rc) => {
        if (rc) {
          this.OnAppointmentCancelled.emit(this.bookAptInfo.apt);
          this.CloseForm(true);
        }
      });
    }
  }

  onSessionSelected(e: Session) {
    var changed = this.bookAptInfo.sessionId != e.SessionId;
    this.bookAptInfo.sessionId = e.SessionId;    

    if (this.bookAptInfo.State == AppointmentState.New) {
      this.bookAptInfo.resourceId = null;
      this.transactionService.AddResource(null);      
    }

    this.getData().pipe(take(1)).subscribe(() => {
      this.updateResourceStates();
    });

    this.transactionService.AddSession(e);
    
    this.updateUI();    
  }

  onResourceSelected(e: Resource, updatedDelays = false, updateDateTime = false) {
    console.log('Selected Resource', e);
    this.bookAptInfo.resourceId = e.ResourceId;
    this.bookAptInfo.startTime = e.StartTime;
    this.bookAptInfo.waitTime = e.WaitTime;
    this.bookAptInfo.DisclaimerCode = e.DisclaimerCode;
    this.bookAptInfo.SafetyPolicyDisclaimerRequired = e.SafetyPolicyDisclaimerRequired;
    this.bookAptInfo.SkinTypeDisclaimerRequired = e.SkinTypeDisclaimerRequired;

    this.updateUI(updatedDelays, updateDateTime);
    this.transactionService.AddResource(e);
  }

  onBookAppointment(e) {
    // Make sure appointment start date time is adjusted for resource wait time
    if (!this.allowOverlap) {
      const a = dayjs(this.bookAptInfo.requestedStartTime);
      const b = a.add(this.bookAptInfo.waitTime, 'minute');
      const c = b.toDate();
      this.bookAptInfo.apt.StartDateTime = c;
      this.bookAptInfo.startTime = c;
    } else {
      this.bookAptInfo.apt.StartDateTime = this.bookAptInfo.requestedStartTime;
      this.bookAptInfo.startTime = this.bookAptInfo.requestedStartTime;
    }

    const interval = this.sessions.find((i) => i.SessionId === this.bookAptInfo.sessionId)?.Duration || 0;
    const endDateTime = dayjs(this.bookAptInfo.requestedStartTime).add(interval, 'minute').toDate();
    this.bookAptInfo.apt.EndDateTime = endDateTime;
    this.bookAptInfo.endTime = endDateTime;

    if (this.allowOverlap) {
      this.aptService
      .getConflictingAppointment(this.bookAptInfo)
      .pipe(take(1))
      .subscribe((result: Appointment) => {
        if (result) {
          confirm(
            'This appointment will overlap with another appointment. Are you sure you want to continue?',
            'Confirm Booking'
          ).then((result) => {
            if (result) {
              this.createOrUpdateAppointment();
            }
          });
        } else {
          this.createOrUpdateAppointment();
        }
      });
    } else {
      this.createOrUpdateAppointment();
    }
  }

  createOrUpdateAppointment(): void {
    this.bookAptInfo.State = AppointmentState.Booked;
    this.bookAptInfo.Terminal = this.session.ctx.TerminalId;

    this.aptService
      .CreateOrUpdateAppointment(this.bookAptInfo)
      .pipe(take(1))
      .subscribe((r) => {
        const apt: Appointment = Appointment.CreateAppointment(r);
        this.OnAppointmentBooked.emit(apt);
        this.ShowBookingNotification('Appointment booked for ', apt);
        this.CloseForm(true);
      });
  }

  onSaleMade(e: SaleItem[]) {
    this.bookAptInfo.Terminal = this.session.ctx.TerminalId;
    this.bookAptInfo.apt.StartDateTime = this.bookAptInfo.requestedStartTime;

    if (!this.allowOverlap && this.bookAptInfo.startTime !== this.bookAptInfo.requestedStartTime) {
      this.bookAptInfo.apt.StartDateTime = this.bookAptInfo.requestedStartTime;
    } else {
      this.bookAptInfo.startTime = this.bookAptInfo.requestedStartTime;
    }
    
    if (this.bookAptInfo.apt.State < AppointmentState.Paid || this.resourceMgr.IsResourcePaymentAfterSession(this.bookAptInfo.resourceId)) {
      this.aptService.CreateOrUpdateAppointment(this.bookAptInfo)
      .pipe(take(1)).subscribe((r) => {
        const apt: Appointment = Appointment.CreateAppointment(r);

        // Add Apt to Sale Items
        const a: SaleItem = new SaleItem();
        a.SaleItemId = -2;
        a.ProductId = apt.AppointmentId;
        a.SaleItemType = enumSaleItemType.Appointment;
        e.push(a);

        // Make sale
        this.transactionService.MakeSale(this.bookAptInfo.clientId,
          this.session.ctx.BranchId,
          this.session.ctx.TerminalId,
          this.session.ctx.EmployeeId,
          e
        ).pipe(take(1)).subscribe((res) => {
          if (res) {
            if (r.PaymentAfterSession) {
              apt.State = AppointmentState.Completed;
              apt.updateColour(this.session.defaultData.defData.customerSettings);
              this.OnAppointmentSaleMade.emit(apt);
            } else {
              if (apt.State < AppointmentState.Paid) {
                apt.State = AppointmentState.Paid;
              }
              apt.updateColour(this.session.defaultData.defData.customerSettings);
              this.OnAppointmentBooked.emit(apt);
              this.ShowBookingNotification('Sale made for ', apt);
            }
            this.CloseForm(true);
            notify(res.Msg, res.notifyType);
          }
        },
          err => {
            // Handle error
            notify(err, 'error', 10000);
          });
      });
    } else {
      this.transactionService.MakeSale(this.bookAptInfo.clientId,
        this.session.ctx.BranchId,
        this.session.ctx.TerminalId,
        this.session.ctx.EmployeeId,
        e
      ).pipe(take(1)).subscribe((res) => {
        if (res) {
          this.CloseForm(true);
          notify(res.Msg, res.notifyType);
        }
      },
        err => {
          // Handle error
          notify(err, 'error', 10000);
        });
    }
  }

  ShowBookingNotification(prefix: string, r: Appointment) {
    const m = dayjs(r.StartDateTime);
    let StartDateTime = '';
    if (!ConstantsService.isToday(r.StartDateTime)) {
      StartDateTime = ' on ' + m.format('dddd, D MMMM');
    }
    StartDateTime += ' at: ' + m.format('HH:mm');
    const s = prefix + r.ClientName + ' for session: ' + r.SessionName + ' on resource: ' + r.ResourceName + ' starting' + StartDateTime;
    notify(s, 'success', 5000);
  }

  onUpdateSessionDelays(e: SessionDelay) {
    // Save new session delay times
    this.bookAptInfo.PreSessionDelay = e.preSessionDelay;
    this.bookAptInfo.PostSessionDelay = e.postSessionDelay;
    this.bookAptInfo.apt.PreSessionDelay = e.preSessionDelay
    this.bookAptInfo.apt.PostSessionDelay = e.postSessionDelay
    this.PreSessionDelay = e.preSessionDelay;
    this.PostSessionDelay = e.postSessionDelay;

    // Update Appointment in DB with new values if save selected.
    if (this.bookAptInfo.appointmentId>0 && e.save==true)      
    {
      e.AptId=this.bookAptInfo.appointmentId;
      this.aptService.updateAppointmentDelay(e).pipe(take(1)).subscribe();    
    }

    this.getData().pipe(take(1)).subscribe(() => {
      // re-select resource - this will update the transaction, timings, waittimes and UI
      if (this.resources && (this.resources.length > 0) && this.bookAptInfo.resourceId) {
        const resource = this.resources.find(i => i.ResourceId === this.bookAptInfo.resourceId);
        if (resource) {
          this.onResourceSelected(resource, true);
        }
      }
    });    
  }
}
